import Service from '@/helpers/service'

export default {

    requestOtp(username) {
        return Service().post('auth/forgot-password/request-otp', {username: username});
    },
    reset(username, otp_code, password) {
        return Service().post('auth/forgot-password/reset', {username: username, otp_code: otp_code, password: password});
    },
}
